// src/api/logout.ts
import api from "./axios";
export async function logout() {
  try {
    await api.post("/auth/logout"); // revoca token y borra cookie
  } catch {
    /* ignora errores (p.ej. token ya revocado) */
  } finally {
    localStorage.removeItem("token");
    sessionStorage.removeItem("jwt");
    localStorage.removeItem("mustChangePwd");
  }
}
